export const ADD_COMMON_LOADER = 'ADD_COMMON_LOADER';

export const REMOVE_COMMON_LOADER = 'REMOVE_COMMON_LOADER';
